import { Language, languageOptionsMap } from 'models/Patient';

import {
  TicketPatientContactModel,
  TicketPatientContactType
} from 'components/Ticket/TicketRow/TicketContact/TicketContact.types';

export function getTicketMessagesContactFormattedName<T extends TicketPatientContactType>(
  contact: TicketPatientContactModel<T>
): string {
  let preferredLanguage =
    contact.model.language && contact.model.language !== Language.English
      ? ` • Prefers ${languageOptionsMap[contact.model.language!]}`
      : '';
  if (contact.type === TicketPatientContactType.Contact) {
    return `${contact.model.name} (${contact.model.relationship})${preferredLanguage}`;
  }

  return `${contact.model.fullName}${preferredLanguage}`;
}
